import React from 'react';

import {LoginComponent} from "../../components";
import css from './LoginPage.module.css';


const LoginPage = () => {
    return (
        <section className={css.wrap}>
            <LoginComponent/>
        </section>
    );
};

export {LoginPage};